import { render } from "./billContent.vue?vue&type=template&id=f8b790dc"
import script from "./billContent.vue?vue&type=script&lang=js"
export * from "./billContent.vue?vue&type=script&lang=js"

import "./billContent.vue?vue&type=style&index=0&id=f8b790dc&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-17.4.2.tgz_vue@3.2.13_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__